
// This file is deprecated in favor of sonner toasts.
// Import { Toaster } from "sonner" instead of this component.
// For toast functionality, use the hooks/use-toast.ts functions

import { useToast } from "@/hooks/use-toast"
import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from "@/components/ui/toast"

// This component is kept for backward compatibility but should not be used in new code
export function Toaster() {
  const { toasts } = useToast()

  console.warn("Deprecated Toaster component used. Please use sonner's Toaster instead.")

  return (
    <ToastProvider>
      {toasts.map(function ({ id, title, description, action, ...props }) {
        return (
          <Toast key={id} {...props}>
            <div className="grid gap-1">
              {title && <ToastTitle>{title}</ToastTitle>}
              {description && (
                <ToastDescription>{description}</ToastDescription>
              )}
            </div>
            {action}
            <ToastClose />
          </Toast>
        )
      })}
      <ToastViewport />
    </ToastProvider>
  )
}
